import { graphql } from "~/gql";

export const WORK_FRAGMENT = graphql(/* GraphQL */ `
  fragment WorkParts on Work {
    __typename
    id
    createdAt
    phaseId
    matterId
    updatedAt
    timeLower
    timeUpper
    timeSingle
    workEffort
    topDownRateDiscount
    price {
      lower
      upper
      single
    }
    selectedRate {
      id
      description
      amount
      clientId
      feeEarnerId
      feeEarnerLevelId
      deprecated
      currency {
        id
        code
        symbol
      }
    }
    feeEarnerLevel {
      id
      description
      order
    }
    feeEarner {
      id
      createdAt
      updatedAt
      name
      deprecated
      feeEarnerLevel {
        createdAt
        updatedAt
        id
        description
        order
      }
      rates {
        id
        createdAt
        updatedAt
        description
        amount
        clientId
        feeEarnerId
        feeEarnerLevelId
        deprecated
        currency {
          id
          code
          symbol
        }
      }
      practiceArea {
        id
        name
      }
    }
    cost {
      lower
      upper
      single
    }
    costRate
    price {
      lower
      upper
      single
    }
  }
`);
